import { render, staticRenderFns } from "./FolderComponent.vue?vue&type=template&id=370b40f4&scoped=true"
import script from "./FolderComponent.vue?vue&type=script&lang=js"
export * from "./FolderComponent.vue?vue&type=script&lang=js"
import style0 from "./FolderComponent.vue?vue&type=style&index=0&id=370b40f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b40f4",
  null
  
)

export default component.exports